import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import shiftService from '../services/shiftService';

function ShiftUpload() {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileExt = selectedFile.name.split('.').pop().toLowerCase();
      if (!['xlsx', 'xls'].includes(fileExt)) {
        setError('Please select a valid Excel file (.xlsx or .xls)');
        setFile(null);
        return;
      }
      setFile(selectedFile);
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Upload button clicked, file:', file);

    if (!file) {
      setError('Please select a file to upload');
      return;
    }

    setUploading(true);
    setError('');
    setSuccess('');

    try {
      console.log('Uploading file...');
      const result = await shiftService.uploadShift(file);
      console.log('Upload result:', result);
      setSuccess('Shift data uploaded successfully!');
      setTimeout(() => {
        navigate('/shifts');
      }, 2000);
    } catch (err) {
      console.error('Upload error:', err);
      setError(err.response?.data?.message || 'Failed to upload file. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="app-container">
      <div className="container" style={{ maxWidth: '800px' }}>
        <div className="page-header">
          <h1>Upload Shift Data</h1>
          <p>Upload your Excel file containing shift schedules</p>
        </div>

        <div className="card" style={{ background: '#fff3cd', borderLeft: '4px solid #ffc107' }}>
          <h3 style={{ color: '#856404', marginBottom: '10px' }}>ℹ️ File Requirements:</h3>
          <ul style={{ marginLeft: '20px', color: '#856404' }}>
            <li>File must be in Excel format (.xlsx or .xls)</li>
            <li>File should contain staff codes, names, dates, and shift times</li>
            <li>Maximum file size: 10MB</li>
            <li>The system will automatically process day/night shifts, leaves, and holidays</li>
          </ul>
        </div>

        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <div className="card">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="file">Select Excel File</label>
              <input
                type="file"
                id="file"
                accept=".xlsx,.xls"
                onChange={handleFileChange}
                className="form-control"
                disabled={uploading}
              />
              {file && (
                <div style={{ marginTop: '10px', color: '#059669', fontWeight: 600 }}>
                  Selected: {file.name} ({(file.size / 1024).toFixed(2)} KB)
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!file || uploading}
              >
                {uploading ? 'Uploading...' : '📤 Upload File'}
              </button>
              <button
                type="button"
                onClick={() => navigate('/shifts')}
                className="btn btn-secondary"
                disabled={uploading}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>

        <div className="card">
          <div className="card-header">How the system processes your data:</div>
          <ul style={{ lineHeight: '1.8', color: '#666' }}>
            <li><strong>Day Shift (No Night Differential):</strong> Shows ✓ checkmark</li>
            <li><strong>Night Shift (10pm-6am):</strong> Shows actual shift time</li>
            <li><strong>Leave Days:</strong> LWP (Leave With Pay) or LWOP (Leave Without Pay)</li>
            <li><strong>Holidays:</strong> Automatically marked as HOLIDAY</li>
            <li><strong>Weekends:</strong> Saturday and Sunday are excluded</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ShiftUpload;
